import { Environment } from '../config/Environment'
import { analytics } from 'payment-widget-core'
import { attachLeaveTracking } from '../analytics/funnel'

/**
 * Инициализация воронки аналитики платёжной формы.
 * Включается флагом REACT_APP_ANALYTICS_IS_ENABLED.
 * Пока провайдер не проинициализирован — analytics.track() no-op.
 */
let isEnabled = false
try {
  isEnabled =
    JSON.parse(String(Environment.REACT_APP_ANALYTICS_IS_ENABLED).toLowerCase()) === true
} catch (e) {
  //
}

if (isEnabled) {
  analytics.init({
    endpoint: Environment.REACT_APP_ANALYTICS_ENDPOINT || undefined,
    signKey: Environment.REACT_APP_ANALYTICS_SIGN_KEY || 'unsecure',
    batchSize: 1,
  })
  attachLeaveTracking()
}
